import styles from "../../pages/DataProt/DataProt.module.css"
import Footer from "../../components/Footer/Footer";

export default function Imprint(){
    document.title = "Impressum - Alwinowitch"
    return (
        <div className={styles.wrapper}>
        <div className={`${styles.container} container`}>
          <h1 className="mb-4 mt-5">Impressum</h1>

          <h5>Angaben gemäß § 5 TMG</h5>
          <p>
            Alwin Berger<br />
            Bautzener Straße 5<br />
            02730 Ebersbach-Neugersdorf
          </p>

          <h5>Kontakt:</h5><br />
            E-Mail: <a href="mailto:alwinb22005@gmail.com">alwinb22005@gmail.com</a>
          

          <h5 className="mt-4">Haftung für Inhalte</h5>
          <p>
            Die Inhalte dieser Website wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität können wir jedoch keine Gewähr übernehmen.
          </p>

          <h5>Haftung für Links</h5>
          <p>
            Diese Website enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Für diese Inhalte ist stets der jeweilige Anbieter oder Betreiber verantwortlich.
          </p>

          <h5>Urheberrecht</h5>
          <p>
            Die durch den Seitenbetreiber erstellten Inhalte unterliegen dem deutschen Urheberrecht.
          </p>

          <h5>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:</h5>
          <p>
            Alwin Berger<br />
            Bautzener Straße 5<br />
            02730 Ebersbach-Neugersdorf
          </p>
        </div>
        <Footer bgColor={"lightgrey"} fontColor={"black"}/>
        </div>
    );
}